// Hardcoded filter options for mobile lines
export const LINE_STATUS_OPTIONS = [
  { value: 'used', label: 'Active', color: 'green' },
  { value: 'suspended', label: 'Suspendue', color: 'yellow' },
  { value: 'restricted', label: 'Restreinte', color: 'orange' },
  { value: 'cancelled', label: 'Annulée', color: 'red' },
  { value: 'rejected', label: 'Rejetée', color: 'red' },
  {
    value: 'settingInProgress',
    label: 'Paramétrage en cours',
    color: 'blue',
  },
  {
    value: 'suspensionInProgress',
    label: 'Suspension en cours',
    color: 'yellow',
  },
  {
    value: 'reactivationInProgress',
    label: 'Réactivation en cours',
    color: 'blue',
  },
  {
    value: 'terminationInProgress',
    label: 'Résiliation en cours',
    color: 'red',
  },
  {
    value: 'scheduledTermination',
    label: 'Résiliation programmée',
    color: 'red',
  },
  {
    value: 'cancelScheduledTerminationInProgress',
    label: 'Annulation résiliation en cours',
    color: 'blue',
  },
  {
    value: 'restrictionInProgress',
    label: 'Restriction en cours',
    color: 'orange',
  },
  {
    value: 'scheduleTerminationInProgress',
    label: 'Résiliation en cours',
    color: 'red',
  },
  {
    value: 'swapSimInProgress',
    label: 'Changement de SIM en cours',
    color: 'blue',
  },
] as const;

export const LINE_TYPE_OPTIONS = [
  {
    value: 'classic',
    label: 'Ligne Mobile',
    description: 'Ligne téléphonique classique',
  },
  {
    value: 'dataonly',
    label: 'SIM Data',
    description: 'SIM card pour données uniquement',
  },
] as const;

export const OPERATOR_OPTIONS = [
  { value: 'Orange', label: 'Orange' },
  { value: 'SFR', label: 'SFR' },
  { value: 'Bouygues', label: 'Bouygues Telecom' },
] as const;

// Filter presets for common use cases
export const FILTER_PRESETS = {
  all: {
    label: 'Toutes les lignes',
    filters: {},
  },
  active: {
    label: 'Lignes actives',
    filters: {
      status: ['used'] as string[],
    },
  },
  inactive: {
    label: 'Lignes inactives',
    filters: {
      status: ['suspended', 'restricted', 'cancelled', 'rejected'] as string[],
    },
  },
  classic: {
    label: 'Lignes mobiles',
    filters: {
      type: ['classic'] as string[],
    },
  },
  dataOnly: {
    label: 'SIM Data',
    filters: {
      type: ['dataonly'] as string[],
    },
  },
  orange: {
    label: 'Orange uniquement',
    filters: {
      operator: ['Orange'] as string[],
    },
  },
} as const;

export type FilterPreset = keyof typeof FILTER_PRESETS;
export type LineStatus = (typeof LINE_STATUS_OPTIONS)[number]['value'];
export type LineType = (typeof LINE_TYPE_OPTIONS)[number]['value'];
export type Operator = (typeof OPERATOR_OPTIONS)[number]['value'];

// Helper functions
export const getStatusLabel = (status: string): string => {
  const option = LINE_STATUS_OPTIONS.find((opt) => opt.value === status);
  return option?.label || status;
};

export const getTypeLabel = (type: string): string => {
  const option = LINE_TYPE_OPTIONS.find((opt) => opt.value === type);
  return option?.label || type;
};

export const getOperatorLabel = (operator: string): string => {
  const option = OPERATOR_OPTIONS.find((opt) => opt.value === operator);
  return option?.label || operator;
};

export const getStatusColor = (status: string): string => {
  const option = LINE_STATUS_OPTIONS.find((opt) => opt.value === status);
  return option?.color || 'gray';
};
